import React from "react"
import Fade from "react-reveal/Fade"
import data from "../yourdata"

// import scss from news
import "../styles/about.scss"
import "../styles/include-media.scss"

const About = () => {
  return (
    <div className="secion" id="about">
      <div className="container">
        <div className="about-section">
          <div className="content">
          <span>
          <a href = '/'>Home</a>
          </span>
            <Fade bottom cascade>
              <h2>Singular Perturbation-based Reinforcement Learning of Two-Point Boundary Optimal Control Systems</h2>
            </Fade>
            <p>
            We solve the problem of two-point boundary optimal control of linear time-varying systems with unknown model dynamics using reinforcement learning. Leveraging singular perturbation theory techniques, we transform the time-varying optimal control problem into two time-invariant subproblems. This allows the utilization of an off-policy iteration method to learn the controller gains. We show that the performance of the learning-based controller approximates that of the model-based optimal controller and the approximation accuracy improves as the control problem's time horizon increases. We also provide a simulation example to verify the results.
            </p>
            <div>
                <h3>Can Catch us at:</h3>
            </div>
            <div className="social-icons">
            {data.social.map((socialLink, index) => (
              <a
                key={index}
                href={socialLink.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={socialLink.img} alt="icons"></img>
              </a>
            ))}
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About